// extracted by mini-css-extract-plugin
module.exports = {"table":"VaccinatedTable_table__3qVHg","rotate":"VaccinatedTable_rotate__2DPnp"};